/* veggiet PDP Instagram viewer (2026-10-12). No dependencies, no Instagram embed. */
(function () {
  'use strict';
  if (window.__vgIgInit) return;
  window.__vgIgInit = true;

  var LOCK = 'vg-ig-lock';

  function unlock() { document.documentElement.classList.remove(LOCK); }

  function wire(section) {
    var viewer = section.querySelector('[data-vg-ig-viewer]');
    var tiles = Array.prototype.slice.call(section.querySelectorAll('[data-vg-ig-open]'));
    if (!viewer || !tiles.length) return;
    var img = viewer.querySelector('[data-vg-ig-img]');
    var handle = viewer.querySelector('[data-vg-ig-handle]');
    var caption = viewer.querySelector('[data-vg-ig-caption]');
    var tag = viewer.querySelector('[data-vg-ig-tag]');
    var link = viewer.querySelector('[data-vg-ig-link]');
    var dots = viewer.querySelector('[data-vg-ig-dots]');
    var shop = viewer.querySelector('[data-vg-ig-shop]');
    var current = 0;
    var lastFocus = null;

    dots.innerHTML = tiles.map(function () { return '<span></span>'; }).join('');

    function show(i) {
      current = (i + tiles.length) % tiles.length;
      var d = tiles[current].dataset;
      img.src = d.img;
      img.alt = d.caption || '';
      handle.textContent = '@' + d.handle;
      caption.textContent = d.caption || '';
      tag.textContent = d.tag || '';
      tag.style.display = d.tag ? '' : 'none';
      link.href = d.url || '#';
      link.textContent = d.reel === 'true' ? 'Watch on Instagram' : 'View on Instagram';
      Array.prototype.forEach.call(dots.children, function (s, k) { s.classList.toggle('is-on', k === current); });
      var next = tiles[(current + 1) % tiles.length];
      if (next) { var pre = new Image(); pre.src = next.dataset.img; }
    }

    function open(i) {
      lastFocus = document.activeElement;
      show(i);
      viewer.hidden = false;
      document.documentElement.classList.add(LOCK);
      viewer.querySelector('.vg-ig-viewer__x').focus();
      if (window.gtag) { try { window.gtag('event', 'vg_ig_open', { post_handle: tiles[current].dataset.handle }); } catch (e) { /* analytics optional */ } }
    }

    function close() {
      viewer.hidden = true;
      unlock();
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    tiles.forEach(function (t, i) { t.addEventListener('click', function () { open(i); }); });
    /* Window capture phase: runs before veggiet-site-fixes.js, whose document-level capture handler
       swallows taps on any "close" control while a (hidden) Klaviyo popup is in the DOM. */
    window.addEventListener('click', function (e) {
      if (viewer.hidden || !viewer.contains(e.target)) return;
      if (e.target.closest('[data-vg-ig-close]')) { e.stopPropagation(); close(); }
      else if (e.target.closest('[data-vg-ig-prev]')) { e.stopPropagation(); show(current - 1); }
      else if (e.target.closest('[data-vg-ig-next]')) { e.stopPropagation(); show(current + 1); }
    }, true);
    link.addEventListener('click', function () {
      if (window.gtag) { try { window.gtag('event', 'vg_ig_outbound', { post_handle: tiles[current].dataset.handle }); } catch (e) { /* optional */ } }
    });
    if (shop) {
      shop.addEventListener('click', function () {
        close();
        var target = document.querySelector('.vg-buy, [id^="ProductInfo-"], product-info, .product__info-wrapper');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        else window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
    document.addEventListener('keydown', function (e) {
      if (viewer.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight') show(current + 1);
      if (e.key === 'ArrowLeft') show(current - 1);
    });

    /* swipe left/right inside the viewer */
    var stage = viewer.querySelector('.vg-ig-viewer__stage');
    var x0 = null;
    stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
      x0 = null;
    }, { passive: true });
  }

  /* never leave the page scroll-locked (lesson from the 2026-10-11 popup bug) */
  window.addEventListener('pagehide', unlock);
  window.addEventListener('pageshow', unlock);

  function init() { Array.prototype.forEach.call(document.querySelectorAll('[data-vg-ig]'), wire); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (e) { var s = e.target.querySelector('[data-vg-ig]'); if (s) wire(s); });
})();
